import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// import images
import logoSm from "../../assets/images/logo-sm.png"
import Footer from "../../pages/Authentication/Footer"
import Logo from "../../assets/images/rema.png"

const PasswordSection = props => {
  const [error, setError] = useState(props.error)
  const [loading, setloading] = useState(false)
  useEffect(() => {
    setError(props.error)
    setloading(false)
  }, [props.error])
  return (
    <div className="account-pages">
      <div
        className="container  justify-content-center d-flex flex-column tw-right-0 tw-left-0 py-5">
        <div className="row pt-5 justify-content-center">
          <div className="col-md-8 col-lg-8  col-xxl-5">
            <div className="card  shadow-md rounded-4">
              <div className="card-body">
                <div className="d-flex mb-3 justify-content-center">
                  <div
                    className="tw-h-24 d-flex justify-content-center align-items-center tw-w-24 border border-warning border-3 shadow-sm rounded-circle" style={{width:'6rem',height:'6rem'}}>
                    <img src={Logo} alt="Rema Logo" className="img-fluid"/>
                  </div>
                </div>
                <h5 className="fw-semibold  text-center">Password Creation</h5>
                <p className="text-center text-muted tw-text-xs">
                  Kindly create your password
                </p>
                <div className="p-3">
                  <AvForm
                    className="mt-4"
                    onValidSubmit={(e, v) => {
                      setloading(true)
                      let data = {
                        ...props.user,
                        username: props.user.email,
                        password: v.password,
                      }
                      props.handleValidSubmit(e, data)
                    }}
                  >
                    {props.registrationError && props.registrationError ? (
                      <Alert color="danger">{props.registrationError}</Alert>
                    ) : null}

                    {props.error && props.error ? (
                      <Alert color="danger">{props.error}</Alert>
                    ) : null}

                    <div className="mb-3">
                      <AvField
                        name="password"
                        label="Password"
                        type="password"
                        required
                        placeholder="Enter Last Password"
                      />
                    </div>
                    <div className="mb-3">
                      <AvField
                        name="cPassword"
                        label="Confirm Password"
                        type="password"
                        errorMessage="Passwords do not match"
                        validate={{
                          required: { value: true },
                          match: { value: "password" },
                        }}
                        placeholder="Confirm Password"
                      />
                    </div>

                    <div className="mb-3 row">
                      <div className="col-12 text-end">
                        <button
                          className="btn btn-primary w-md waves-effect waves-light"
                          type="submit"
                        >
                          Create Password
                        </button>
                      </div>
                    </div>
                  </AvForm>
                  <div className=" text-center">
                    <p>
                      Already have an account ?{" "}
                      <Link to="login" className="fw-medium text-primary">
                        {" "}
                        Login{" "}
                      </Link>{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PasswordSection
